<!-- START: Section 1 -->
<section class="partner-intro">
  <div class="box">
    <div class="box__left">
      <div class="box__subheading color-blue"
        ><span> {{ 'BECOME_OUR_PARTNER.SECTION_INTRO.SUB_HEADING' | translate }} </span>
      </div>
      <h1 class="box__heading color-gray box__heading {{ translate.currentLang }}"
        >{{ 'BECOME_OUR_PARTNER.SECTION_INTRO.HEADING' | translate }}
      </h1>
      <div class="box__heading-detail box__heading--mw"
        ><span> {{ 'BECOME_OUR_PARTNER.SECTION_INTRO.DETAIL' | translate }}</span>
      </div>
      <div class="box__btn">
        <button
          id="becomePartnerFormLink"
          (click)="scrollToTarget('partnerFlowaccountForm-id')"
          class="box__btn--layout"
        >
          <span>{{ 'BECOME_OUR_PARTNER.SECTION_INTRO.BECOME_PARTNER_BUTTON' | translate }}</span>
        </button>
      </div>
    </div>
    <div class="box__right">
      <picture>
        <source
          srcset="
            https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/Become-our-partner-with-FlowAccount.webp
          "
          type="image/webp"
        />
        <img
          src="https://flowaccountcdn.com/new_landing/image/accountingfirm/become-our-partner/Become-our-partner-with-FlowAccount.jpg"
          width="100%"
          loading="eager"
          alt="{{ getAltText }}"
          class="box__image"
        />
      </picture>
    </div>
  </div>
</section>
